/**
 * Created by efowler on 4/1/14.
 */
'use strict';

frontendApp.controller('AddUserModalCtrl', ['$scope', '$uibModalInstance', 'project', 'roles', 'InviteService', 'HttpService', 'ConfigService', 'NotificationService', function($scope, $uibModalInstance, project, roles, InviteService, HttpService, ConfigService, NotificationService) {

    $scope.project = project;

    $scope.saving = false;

    $scope.step = 1;
    $scope.maxSteps = 1;

    $scope.close = function() {
        if ($scope.saving) return;
        $uibModalInstance.close();
    };

    var userRole = _.findWhere(roles, { name : 'ROLE_USER' });

    $scope.invite = {
        projectId: project.id,
        email: "",
        role: (userRole ? userRole.id : "")
    };

    $scope.sendInvite = function(invite) {

        $scope.saving = true;
        var newInvite = InviteService.create(invite.projectId, invite.email, invite.role);

        InviteService.save(newInvite, function(invite) {

            $scope.saving = false;
            $scope.close();

            NotificationService.addSuccess({
                title: 'Invite Sent',
                description: invite.email + " as " + invite.role.name,
                timeout: 5000
            });

        }, function(data) {
            $scope.saving = false;
        });
    };




}]);

